import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Lets a slow/cold-starting backend keep running in the background instead of
// making the user wait for it — resolves after `ms` even if `promise` hasn't
// settled yet, but never rejects (so callers can't mistake a timeout for a
// real failure). The original promise is left to resolve/reject on its own.
export function withTimeout(promise, ms) {
  return new Promise((resolve) => {
    const timer = setTimeout(() => resolve({ timedOut: true }), ms);
    promise.then(
      (value) => { clearTimeout(timer); resolve({ timedOut: false, value }); },
      (error) => { clearTimeout(timer); resolve({ timedOut: false, error }); },
    );
  });
}
